module.exports = __webpack_public_path__ + "img/ie.20b2dd79.svg";